import { DatePicker } from "antd";
import DailyAppointments from "./DailyAppointments";
import DailyDashboardTraffic from "./DailyDashboardTraffic";
import arLocale from "antd/es/date-picker/locale/ar_EG";
import enLocale from "antd/es/date-picker/locale/en_US";
import { useIntl } from "react-intl";
import { reservationTrue } from "../../../assets/SVGs/SVGs";
import { useState } from "react";
import dayjs from "dayjs";
type Props = {};

const SalonAnalytics = (props: Props) => {
  const [selectedDate, setSelectedDate] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );
  const intl = useIntl();
  const { locale } = useIntl();
  return (
    <div className="flex items-center flex-col gap-4">
      <div className="w-full flex items-center justify-between">
        <div className="flex gap-2 items-center">
          <span className="flex items-center">{reservationTrue()}</span>
          <span className="text-color-primary text-lg font-semibold">
            Analytics
          </span>
        </div>
        <DatePicker
          locale={locale === "ar" ? arLocale : enLocale}
          style={{ width: 200, backgroundColor: "#FFFFFF", border: 0 }}
          picker="date"
          placeholder={intl.formatMessage({ id: "intl.form.dateSelection" })}
          value={dayjs(selectedDate)}
          onChange={(date) => {
            if (!date) {
              setSelectedDate(dayjs(new Date()).format("YYYY-MM-DD"));
              return;
            }
            setSelectedDate(date?.format("YYYY-MM-DD"));
          }}
        />
      </div>
      <DailyAppointments selectedDate={selectedDate} />
      {/* <DailyDashboardTraffic /> */}
    </div>
  );
};

export default SalonAnalytics;
